import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const PolicyIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.984 8.59997H18.528L12.984 3.10397V8.59997ZM15.984 13.616V11.6H8.01601V13.616H15.984ZM15.984 17.6V15.584H8.01601V17.6H15.984ZM14.016 1.61597L20.016 7.61597V19.616C20.016 20.16 19.816 20.624 19.416 21.008C19.016 21.392 18.544 21.584 18 21.584H6.00001C5.45601 21.584 4.98401 21.392 4.58401 21.008C4.18401 20.624 3.98401 20.16 3.98401 19.616L4.03201 3.58397C4.03201 3.03996 4.22401 2.57597 4.60801 2.19197C4.99201 1.80796 5.45601 1.61597 6.00001 1.61597H14.016Z'
                fill='currentColor'
            />
        </>
    ),
})

PolicyIcon.displayName = 'PolicyIcon'
